import {createAction} from '@reduxjs/toolkit'

import {BankCodeType, RefundCodeType} from '@web/core/constants'

import {RefundAccountItem} from './interfaces'

/** 무통장 입금 은행 선택 */
export const selectVirtualAccountBankCode = createAction<Maybe<BankCodeType>>('payNext/selectVirtualAccountBankCode')

/** 환불 타입 */
export const selectRefundMethod = createAction<RefundCodeType>('payNext/selectRefundMethod')

/** 환불계좌목록 정보 변경 */
export const updateRefundAccounts = createAction<RefundAccountItem[]>('payNext/updateRefundAccounts')

/** 환불계좌목록 정보 변경 */
export const selectRefundAccountsKey = createAction<string>('payNext/selectRefundAccountsKey')

// 결제수단 분리전까지 임시로 사용
export const updateFamilyPayMemo = createAction<string>('payNext/updateFamilyPayMemo')
